import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GraduationCap, ArrowRight } from "lucide-react";
import api from "../lib/api";
import { Spinner, SectionLabel } from "../components/Primitives";

export default function Quizzes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/quizzes").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="quizzes-page">
      <div className="border-b border-edge bg-ash">
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-12">
          <SectionLabel>Assess</SectionLabel>
          <h1 className="font-serif text-5xl font-semibold text-bone lg:text-6xl">Quizzes</h1>
          <p className="mt-5 max-w-2xl text-lg text-muted">
            Sourced, explanatory assessments. Every answer comes with the historical context behind it.
          </p>
        </div>
      </div>

      {loading ? (
        <Spinner />
      ) : (
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
          <div className="grid gap-6 md:grid-cols-2">
            {items.map((q, i) => (
              <motion.div key={q.slug} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}>
                <Link
                  to={`/quizzes/${q.slug}`}
                  data-testid={`quiz-card-${q.slug}`}
                  className="group flex items-start gap-5 border border-edge bg-ink p-8 transition-colors hover:border-gold/50"
                >
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center border border-gold/40 text-gold">
                    <GraduationCap className="h-6 w-6" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-serif text-2xl text-bone group-hover:text-gold">{q.title}</h3>
                    <p className="mt-2 text-sm text-muted">{q.description}</p>
                    <div className="mt-4 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.15em] text-gold">
                      {q.questions.length} questions <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
